
@switch (columnId) {
  @case (BinFileOrderByEnum.Id) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case (BinFileOrderByEnum.FileName) {
    <lib-text-table-column>
      {{ element.fileName }}
    </lib-text-table-column>
  }
  @case (BinFileOrderByEnum.CreatedUtc) {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case (BinFileOrderByEnum.UpdatedUtc) {
    <lib-date-time-label [dateUtc]="element.updatedUtc"></lib-date-time-label>
  }
  @case (BinFileOrderByEnum.Date) {
    <lib-date-time-label [dateUtc]="element.date"></lib-date-time-label>
  }
  @case (BinFileOrderByEnum.Status) {
    <lib-status-chip
      class="bin-file-statuses"
      [status]="element.status">
    </lib-status-chip>
  }
  @case ('reprocess') {
    <lib-vitu-tooltip text="Reprocess">
      <i class="far fa-redo global-table-cell-image-link" (click)="onClickReprocess()"></i>
    </lib-vitu-tooltip>
  }
  @case ('download') {
    <lib-vitu-tooltip text="Download">
      <i class="far fa-file-download global-table-cell-image-link" (click)="onClickDownload()"></i>
    </lib-vitu-tooltip>
  }
  @default {
  }
}
